import * as React from 'react';
import { List } from 'react-native-paper';
import { StyleSheet, View, Text } from 'react-native';
import { COLORS, FONTS } from '../constants';

const DefinitionsList = () => {

  const definitionsData = require('../../assets/json/definitions.json')

  return (

    <View style={styles.container}>

      <List.Section
        style={{ backgroundColor: COLORS.background }}
      >

        <List.Accordion
          title="Marszobieg"
          left={props => <List.Icon {...props} icon="folder" />}
        // style={{ backgroundColor : COLORS.dark }}
        >

          <Text style={styles.content}>
            {definitionsData[0].definition}</Text>

        </List.Accordion>

        <List.Accordion
          title="Pływanie"
          left={props => <List.Icon {...props} icon="folder" />}>

          <Text style={styles.content}>
            {definitionsData[1].definition}</Text>

        </List.Accordion>

        <List.Accordion
          title="Podciąganie"
          left={props => <List.Icon {...props} icon="folder" />}>

          <Text style={styles.content}>
            {definitionsData[2].definition}</Text>

        </List.Accordion>

        <List.Accordion
          title="Pompki"
          left={props => <List.Icon {...props} icon="folder" />}>

          <Text style={styles.content}>
            {definitionsData[3].definition}</Text>

        </List.Accordion>

        <List.Accordion
          title="10 x 10"
          left={props => <List.Icon {...props} icon="folder" />}>

          <Text style={styles.content}>
            {definitionsData[4].definition}</Text>

        </List.Accordion>

        <List.Accordion
          title="Koperta"
          left={props => <List.Icon {...props} icon="folder" />}>

          <Text style={styles.content}>
            {definitionsData[5].definition}</Text>

        </List.Accordion>

        <List.Accordion
          title="Brzuszki"
          left={props => <List.Icon {...props} icon="folder" />}>

          <Text style={styles.content}>
            {definitionsData[6].definition}</Text>

        </List.Accordion>

      </List.Section>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    // alignItems: 'center',
    // justifyContent: 'center',
    flex: 1,
    // backgroundColor: COLORS.background,
    marginBottom: 20,
    paddingBottom: 20,
  },
  title: {
    ...FONTS.info,
    marginBottom: 10,
    paddingLeft: 30
  },
  content: {
    color: COLORS.light,
    fontWeight: '300',
    fontSize: 14,
    textAlign: 'justify',
    paddingRight: 30,
    paddingLeft: 30,
    paddingVertical: 5
  },
  bg: {
    backgroundColor: COLORS.background,
    width: "100%",
    height: "100%"
  }
});

export default DefinitionsList;